<template>
  <div class="c-plan">
    <!-- filter -->
    <plan-filter placeholder="请输入计划名称或ID" @on-change="filterData" @on-search="searchFilterData" />

    <Row class="c-control-btn">
      <Col span="8">
        <Dropdown class="c-btn-group" @on-click="betch">
          <a href="javascript:void(0)">
            批量操作
            <Icon type="ios-arrow-down"></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem :name="1">启用</DropdownItem>
            <DropdownItem :name="0">暂停</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Col>
      <Col span="8" offset="8">
        <Button class="g-pull-right" icon="md-download" @click="down">数据导出</Button>
        <Button class="g-pull-right" @click="modalColumn = true">自定义列</Button>
      </Col>
    </Row>

    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <plan-table
          ref="planTable"
          :height="tableHeight"
          :loading="loading"
          :data="tableList"
          :columns="tableCols"
          @on-refresh="getData"
          @on-sort="sortTable"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
        />
      </Viewport>
    </div>

    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" :subTitle="['基础数据', '报表数据', '留存数据']" @on-select="selectColumn" />
  </div>
</template>
<script>
import mixin from './mixin'
import mixins from '../mixins/mixin'
import columns from '../data/plandata_column'
import { isArray } from '@/common/js/utils' // , timeout, isEmpty, getKeyOfData
import { setLocal } from '@/common/js/api'
import PlanFilter from './components/plan-filter'
import PlanTable from './components/plan-table'
import { listProjectPlanAnalysis } from '@/api/manage.model'
import CustomColumn from '@/components/converter/custom-column.vue'
import { HOST_API } from '@/api/config'

export default {
  name: 'smartptomplan',
  mixins: [mixins, mixin],
  components: { PlanFilter, PlanTable, CustomColumn },
  computed: {
    custom() {
      return 'smartptomplan'
    },
    tableCols() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.planTable && this.$refs.planTable.doLayout()
        })
      },
      deep: true
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        projectId: this.projectId,
        sort: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      listProjectPlanAnalysis(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    betch(type) {
      if ([1, 0].includes(type)) {
        this.$refs.planTable.changeBetch(type)
      }
    },
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    down() {
      let url = `${HOST_API}/api/ptom/intelligent/project/downplan`
      url += `?sessionid=${this.$store.state.token}`
      url += `&beginTime=${this.params.beginTime}`
      url += `&endTime=${this.params.endTime}`
      url += `&createBeginTime=${this.params.createBeginTime}`
      url += `&createEndTime=${this.params.createEndTime}`
      this.params.projectId > 0 && (url += `&projectId=${this.params.projectId}`)
      this.params.keyword && (url += `&keyword=${this.params.keyword}`)
      this.params.accountId > 0 && (url += `&adAccountId=${this.params.accountId}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    },
    setLocalPage(size) {
      setLocal('SMARTPTOMPLAN_PAGESIZE', size)
    }
  },
  data() {
    return {
      tableHeight: 330,
      projectId: this.$route.query.projectId,
      tableList: [],
      modalColumn: false, // 自定义列
      columns: columns
    }
  },
  created() {
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    // 同步本地存储自定义列
    if (shows.length) {
      const local_shows = shows
        .filter((ret) => ret && columns.some((met) => met.key === ret))
        .map((ret) => {
          const item = columns.filter((met) => met.key === ret).pop() || {}
          item.show = false
          return item
        })
      const extend_shows = columns
        .filter((ret) => !shows.includes(ret.key))
        .map((ret) => {
          ret.show = true
          return ret
        })
      this.columns = [...local_shows, ...extend_shows]
    } else {
      this.columns = [...columns]
    }
  },
  activated() {
    if (isArray(this.tableList) && this.tableList.length) this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-plan {
  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }

  .c-control-btn {
    width: 100%;
    padding-bottom: 8px;
    background-color: #fff;

    .c-btn-group {
      padding-left: 15px;
      margin-left: 3px;
      line-height: 30px;
      height: 32px;
      border-radius: 3px;
      border: solid 1px #2d8cf0;
      width: 100px;
      display: inline-block;
      vertical-align: middle;
    }

    .c-btn-margin {
      margin-left: 15px;
    }
  }
}
</style>
